<template>
    <div class="policy-item" @click="toDetails(policy)">
        <div class="policy-item-title">{{ policy.newsTitle }}</div>
        <div class="news-item-type">
            <span v-for="tag in policy.tag" :key="tag">{{ tag }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PolicyItem',
    props: {
        policy: {
            type: Object,
            required: true
        }
    },
    methods: {
        toDetails(item) {
            localStorage.setItem('newsId', item.newsId);

            let path = item.seoUrl ? item.seoUrl : item.newsId
            this.$router.push({
                path: `/${path}.html`,
            });
        },
        generateSlug(title) {
            // 将标题中的空格替换为连字符
            let slug = title.toLowerCase().replace(/\s+/g, '-');
            // 将连字符替换为单个连字符
            slug = slug.replace(/-+/g, '');
            slug = slug.replace(/:+/g, '');
            return slug;
        },
    }
}
</script>

<style lang="less" scoped>
.policy-item {
    width: 100%;
    background-color: #fff;
    margin-bottom: 20px;
    cursor: pointer;

    .policy-item-title {
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 18px;
        color: #2C2C2E;
        line-height: 24px;
        text-align: left;
        font-style: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        border-left: 4px solid #E2291E;
        padding-left: 10px;
    }

    .news-item-type {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #AEAEB2;
        line-height: 19px;
        text-align: left;
        font-style: normal;
        margin-top: 6px;
        margin-left: 12px;
    }

    &:hover {
        .policy-item-title {
            color: #E2291E;
        }
    }
}

.policy-item:nth-child(4n) {
    margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/common/policy-item.vue